import {
  whatsappQrProviderOptions,
  WHATSAPP_QR_FEATURE,
} from './masifiWhatsappQr';
import {
  withTwilioVisibility,
  WHATSAPP_TWILIO_FEATURE,
} from './masifiWhatsappTwilio';

// Masifi post-processing of the upstream WhatsApp provider list (channels/Whatsapp.vue consumes it through
// useMasifiWhatsappProviders, so the upstream literal stays byte-identical): appends the QR card when the account has
// feature_whatsapp_qr and hides Twilio unless it has feature_whatsapp_twilio. Returns a new array.
export const masifiWhatsappProviders = (list, { t, isCloudFeatureEnabled }) =>
  withTwilioVisibility(
    [
      ...list,
      ...whatsappQrProviderOptions(
        t,
        isCloudFeatureEnabled(WHATSAPP_QR_FEATURE)
      ),
    ],
    isCloudFeatureEnabled(WHATSAPP_TWILIO_FEATURE)
  );
